import React from "react";

import type { MonitorCheckStatusExternalSilencingRule } from "../../../../../../common/openapi";

import { AppliesTo } from "./common/applies-to";
import { ExternalRuleTiming } from "./common/external-rule-timing";
import { PastRulesAlert } from "./common/past-rules-alert";
import { RuleSelector } from "./common/rule-selector";
import { SilencingNote } from "./common/silencing-note";

export function ExternalPastWithSelector({ rule }: { rule: MonitorCheckStatusExternalSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<PastRulesAlert />
			<RuleSelector />
			<ExternalRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
